/* as.if.radio - die Radioseite (sections/broadcast-radio.liquid), Runde 6.
   Rendert aus dem Zustand von assets/asif-radio-player.js: Programm als
   Zeitleiste mit Jetzt-Marker, Tracklist und Favoriten als Kacheln, das
   Titelblatt (ein Dialog fuer beide), die klebende Bereichsleiste mit
   Scroll-Spy, Kopierknoepfe. Sendungsprofile kommen aus
   window.AsIfRadioProgrammes (assets/asif-radio-widget.js).

   SPA-Vertrag (asif-spa.js): mount() ist idempotent, Aufraeumen ueber
   asif:page:unload und shopify:section:unload. */
(() => {
  'use strict';

  const mounts = window.__asifRadioPageMounts || new Map();
  window.__asifRadioPageMounts = mounts;

  const zone = 'Europe/Berlin';
  const berlinDayKey = (value) => new Intl.DateTimeFormat('sv-SE', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(value));
  const formatTime = (value) => new Intl.DateTimeFormat('de-DE', { timeZone: zone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(value));
  const formatDay = (value) => new Intl.DateTimeFormat('de-DE', { timeZone: zone, weekday: 'short', day: '2-digit', month: '2-digit' }).format(new Date(value));
  const formatWeekday = (value) => new Intl.DateTimeFormat('de-DE', { timeZone: zone, weekday: 'long' }).format(new Date(value));
  const formatDateTime = (value) => new Intl.DateTimeFormat('de-DE', { timeZone: zone, weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(value));


  /* Sprungmarke fuer eine konkrete Sendung, z. B. #programm-daily-pleasure-2026-09-23-1000.
     Gleiches Format baut asif-radio-widget.js fuer den Heute-Streifen. #programm-jetzt
     meint die gerade laufende Sendung (Player unten). */
  const slotAnchor = (item) => {
    const handle = String(item?.programHandle || item?.title || 'sendung').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'sendung';
    return `programm-${handle}-${berlinDayKey(item.startsAt)}-${formatTime(item.startsAt).replace(':', '')}`;
  };
  const readSlotHash = (hash) => {
    const match = /^#programm-(jetzt|.+-(\d{4}-\d{2}-\d{2})-\d{4})$/.exec(String(hash || ''));
    if (!match) return null;
    return { id: `programm-${match[1]}`, day: match[2] || '', now: match[1] === 'jetzt' };
  };

  const programmes = () => window.AsIfRadioProgrammes || {
    profileFor: (item) => ({ title: String(item?.title || 'as.if.radio').replace(/_/g, ' '), tagline: '', description: '' }),
    programmeTitle: (item) => String(item?.title || 'as.if.radio').replace(/_/g, ' '),
    profiles: {}
  };

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const icon = (name) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('radio-glyph', `radio-glyph--${name}`);
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    const paths = {
      heart: 'M12 20.5 4.2 12.6A4.6 4.6 0 0 1 10.7 6l1.3 1.3L13.3 6a4.6 4.6 0 0 1 6.5 6.6Z',
      chevron: 'm9 6 6 6-6 6',
      external: 'M7 17 17 7M9 7h8v8',
      bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4',
      calendar: 'M5 4h14a2 2 0 0 1 2 2v14H3V6a2 2 0 0 1 2-2ZM7 2v4m10-4v4M3 10h18M7 14h3m4 0h3M7 17h3'
    };
    path.setAttribute('d', paths[name] || paths.chevron);
    svg.append(path);
    return svg;
  };

  const durationLabel = (seconds) => {
    const total = Number(seconds);
    if (!Number.isFinite(total) || total <= 0) return '';
    return `${Math.floor(total / 60)}:${String(Math.round(total % 60)).padStart(2, '0')} Min.`;
  };

  const platformLinks = (track) => {
    const query = [track?.artist, track?.title].filter(Boolean).join(' ');
    if (!query) return [];
    return [
      { label: 'Spotify', href: `https://open.spotify.com/search/${encodeURIComponent(query)}` },
      { label: 'YouTube', href: `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}` },
      { label: 'Apple Music', href: `https://music.apple.com/de/search?term=${encodeURIComponent(query)}` }
    ];
  };

  const scheduleSignature = (items) => items.map((item) => [item.id, item.programHandle, item.title, item.startsAt, item.endsAt].join('')).join('');
  const historySignature = (items) => items.map((item) => [item.id, item.playedAt, item.track?.id, item.track?.title, item.artworkUrl].join('')).join('');
  const favoritesSignature = (items) => items.map((item) => [item.id, item.title, item.artworkUrl, item.savedAt].join('')).join('');

  function mount(root) {
    if (!root || mounts.has(root)) return;

    const archiveCleanups = [];
    root.querySelectorAll('[data-recordings-list]').forEach(list => {
      const cards = [...list.querySelectorAll('[data-radio-recording]')];
      const more = list.parentElement.querySelector('[data-recordings-more]');
      const filter = list.parentElement.querySelector('[data-mixtape-filter]');
      const genres = filter?.querySelector('[data-mixtape-genres]');
      const result = filter?.querySelector('[data-mixtape-result]');
      const categories = [['house', 'House'], ['hip-hop', 'Hip-Hop'], ['jazz-soul', 'Jazz & Soul'], ['funk-disco', 'Funk & Disco'], ['rock-indie', 'Rock & Indie'], ['electronic', 'Electronic']];
      const tags = new Map(cards.map(card => [card, new Set((card.dataset.filterGenres || '').split(',').map(value => value.trim()).filter(Boolean))]));
      const badges = new Map();
      const buttons = [];
      let selected = '';
      let visible = 6;
      const matches = () => cards.filter(card => (!selected || tags.get(card).has(selected)));
      const update = () => {
        const filtered = matches();
        const shown = new Set(filtered.slice(0, visible));
        let retained = 0;
        cards.forEach(card => {
          const playing = ['loading', 'ready', 'starting', 'playing', 'blocked'].includes(card.dataset.playback);
          const outside = playing && !shown.has(card);
          if (outside) retained += 1;
          const hide = !shown.has(card) && !playing;
          if (hide && card.contains(document.activeElement)) buttons.find(button => button.dataset.genre === selected)?.focus({ preventScroll: true });
          card.hidden = hide;
          if (filter) {
            let badge = badges.get(card);
            if (outside && !badge) {
              badge = document.createElement('p');
              badge.className = 'radio-recording__filter-note';
              card.prepend(badge);
              badges.set(card, badge);
            }
            if (badge) {
              badge.hidden = !outside;
              badge.textContent = (!filtered.includes(card) ? 'Aktuelle Wiedergabe - außerhalb des Filters' : 'Aktuelle Wiedergabe');
            }
          }
        });
        if (more) {
          more.hidden = visible >= filtered.length;
          if (filter) more.textContent = `Mehr Mixtapes (${Math.max(0, filtered.length - visible)})`;
        }
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.genre === selected)));
        if (result) {
          const name = categories.find(([id]) => id === selected)?.[1];
          const total = filtered.length;
          const count = Math.min(visible, total);
          const message = `${name ? name + ': ' : ''}${count < total ? count + ' von ' : ''}${total} ${total === 1 ? 'Mixtape' : 'Mixtapes'}${retained ? ' · aktuelle Wiedergabe bleibt sichtbar' : ''}`;
          if (result.textContent !== message) result.textContent = message;
        }
      };
      if (filter && genres) {
        genres.replaceChildren();
        [['', 'Alle'], ...categories].forEach(([id, label]) => {
          const count = cards.filter(card => !id || tags.get(card).has(id)).length;
          if (!count) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'radio-mixtape-filter__chip';
          button.dataset.genre = id;
          button.textContent = label;
          const tally = document.createElement('span');
          tally.className = 'radio-mixtape-filter__count';
          tally.textContent = String(count);
          tally.setAttribute('aria-hidden', 'true');
          button.append(tally);
          button.setAttribute('aria-label', `${label}, ${count} Mixtapes`);
          button.onclick = () => { selected = id; visible = 6; update(); };
          buttons.push(button);
          genres.append(button);
        });
        filter.hidden = false;
      }
      const onMore = () => {
        const next = matches()[visible];
        visible += 6;
        update();
        if (next) { next.tabIndex = -1; next.focus({ preventScroll: true }); }
      };
      if (more) more.onclick = onMore;
      const reveal = event => {
        const card = event.detail?.card;
        if (!cards.includes(card)) return;
        selected = '';
        visible = Math.max(6, Math.ceil((cards.indexOf(card) + 1) / 6) * 6);
        update();
      };
      window.addEventListener('asif:recording-reveal', reveal);
      const observer = filter ? new MutationObserver(update) : null;
      observer?.observe(list, { subtree: true, attributes: true, attributeFilter: ['data-playback'] });
      archiveCleanups.push(() => {
        observer?.disconnect();
        window.removeEventListener('asif:recording-reveal', reveal);
        buttons.forEach(button => { button.onclick = null; });
        if (more?.onclick === onMore) more.onclick = null;
      });
      update();
    });

    const days = root.querySelector('[data-radio-days]');
    const timeline = root.querySelector('[data-radio-schedule]');
    const historyList = root.querySelector('[data-radio-history]');
    const historyFoot = root.querySelector('[data-radio-history-foot]');
    const historyMore = root.querySelector('[data-radio-history-more]');
    const favoritesList = root.querySelector('[data-radio-favorites]');
    const nav = root.querySelector('[data-radio-nav]');
    const airplayHint = root.querySelector('[data-radio-airplay-hint]');
    const fallbackArtwork = root.dataset.radioFallbackArtwork || '';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let selectedDay = '';
    let historyLimit = 6;
    let lastState = null;
    let lastScheduleSignature = '';
    let lastHistorySignature = '';
    let lastFavoritesSignature = null;
    let clockTimer = 0;
    let slotTarget = null;   // Sprungziel aus #programm-..., wartet auf die Agenda
    let slotHighlight = { id: '', until: 0 };

    // Enhance the existing articles into an immediate, keyboard-accessible guide.
    const guide = root.querySelector('[data-radio-guide]');
    const guideTabs = [...root.querySelectorAll('[data-radio-guide-tab]')];
    const guidePanels = [...root.querySelectorAll('[data-radio-way]')];
    const selectGuide = (index, focus = false) => {
      guideTabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        const panel = guidePanels.find((item) => item.dataset.radioWay === tab.dataset.radioGuideTab);
        if (panel) panel.hidden = i !== index;
      });
      if (focus) guideTabs[index]?.focus({ preventScroll: true });
    };
    if (guide && guideTabs.length) {
      guidePanels.forEach((panel) => {
        const tab = guideTabs.find((item) => item.dataset.radioGuideTab === panel.dataset.radioWay);
        if (!tab) return;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
      });
      guide.classList.add('is-enhanced');
      root.querySelector('[data-radio-guide-tabs]').hidden = false;
      selectGuide(0);
    }
    const onGuideKey = (event) => {
      const tab = event.target.closest('[data-radio-guide-tab]');
      const index = guideTabs.indexOf(tab);
      if (index < 0) return;
      const next = { ArrowRight: (index + 1) % guideTabs.length, ArrowLeft: (index + guideTabs.length - 1) % guideTabs.length, Home: 0, End: guideTabs.length - 1 }[event.key];
      if (next === undefined) return;
      event.preventDefault();
      selectGuide(next, true);
    };

    /* --- Bausteine ------------------------------------------------------ */

    const artwork = (item, title, size) => {
      const box = element('span', 'radio-cover');
      const image = document.createElement('img');
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = size;
      image.height = size;
      image.src = item.artworkUrl || fallbackArtwork;
      image.addEventListener('error', () => {
        if (fallbackArtwork && image.src !== new URL(fallbackArtwork, window.location.href).href) image.src = fallbackArtwork;
        else { image.remove(); box.textContent = title.slice(0, 1).toUpperCase(); }
      }, { once: true });
      box.append(image);
      return box;
    };

    const heartButton = (trackId, title, isFavorite, className) => {
      const button = element('button', className);
      button.type = 'button';
      button.dataset.asifRadioFavorite = '';
      button.dataset.asifRadioTrackId = trackId;
      button.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
      button.setAttribute('aria-label', isFavorite ? `${title} aus Favoriten entfernen` : `${title} zu Favoriten hinzufügen`);
      button.append(icon('heart'));
      const label = element('span', 'radio-sr', isFavorite ? 'Gespeichert' : 'Speichern');
      label.dataset.asifRadioFavoriteLabel = '';
      button.append(label);
      return button;
    };

    const tile = (item, favorites, source) => {
      const track = item.track || item;
      const title = track.title || 'Unbekannter Titel';
      const artist = track.artist || 'as.if.radio';
      const stamp = item.playedAt || item.savedAt;
      const li = element('li', 'radio-tile');
      const open = element('button', 'radio-tile__open');
      open.type = 'button';
      open.dataset.radioOpen = track.id || '';
      open.dataset.radioSource = source;
      open.setAttribute('aria-label', `${title} von ${artist}: Details`);
      open.append(artwork(item, title, 320));
      const copy = element('span', 'radio-tile__copy');
      copy.append(element('strong', '', title));
      copy.append(element('span', '', artist));
      const time = element('time', '', stamp ? formatTime(stamp) : '');
      if (stamp) time.dateTime = stamp;
      copy.append(time);
      open.append(copy);
      li.append(open);
      if (track.id) li.append(heartButton(track.id, title, favorites.some((favorite) => favorite.id === track.id), 'radio-tile__heart'));
      return li;
    };

    /* Today plus six Berlin calendar days; each day has its own API window. */
    const programmeDates = () => {
      const today = berlinDayKey(new Date());
      const firstDay = new Date(`${today}T12:00:00Z`);
      return Array.from({ length: 7 }, (_, index) => {
        const date = new Date(firstDay); date.setUTCDate(date.getUTCDate() + index);
        return date.toISOString().slice(0, 10);
      });
    };
    let disposed = false;
    let weekItems = [];
    let weekStatus = 'loading';
    const dayCache = new Map();
    let weekController;
    let requestDay = '';
    let requestGeneration = 0;
    const cancelDayRequest = () => {
      requestGeneration += 1;
      weekController?.abort();
      weekController = null;
      requestDay = '';
    };
    const renderSchedule = () => {
      if (!days || !timeline) return;
      const keys = programmeDates();
      const today = keys[0];
      if (!keys.includes(selectedDay)) selectedDay = today;
      const focusedDay = days.contains(document.activeElement) ? document.activeElement.dataset.radioDay : null;
      const focusedCalendar = timeline.contains(document.activeElement) ? document.activeElement.dataset.radioCalendarKey : null;
      days.replaceChildren(); timeline.replaceChildren();
      const dateLabel = key => new Intl.DateTimeFormat('de-DE', { timeZone: zone, day:'numeric',month:'numeric',year:'2-digit' }).format(new Date(`${key}T12:00:00Z`));
      const caption = root.querySelector('[data-radio-week-caption]');
      if (caption) caption.textContent = `${formatWeekday(`${selectedDay}T12:00:00Z`)}, ${dateLabel(selectedDay)} · Kölner Zeit`;
      days.hidden = false;
      const retry = root.querySelector('[data-radio-week-retry]');
      if (retry) retry.hidden = weekStatus !== 'error';
      keys.forEach((key,index) => {
        const button = element('button', 'radio-day');
        button.type = 'button'; button.dataset.radioDay = key;
        button.setAttribute('aria-pressed', String(key === selectedDay));
        const dayLabel = index === 0 ? 'Heute' : index === 1 ? 'Morgen' : formatWeekday(`${key}T12:00:00Z`).slice(0, 2).toLocaleUpperCase('de-DE');
        button.append(element('strong', '', dayLabel), element('span', '', dateLabel(key)));
        button.setAttribute('aria-label', `${index === 0 ? 'Heute, ' : index === 1 ? 'Morgen, ' : ''}${formatWeekday(`${key}T12:00:00Z`)}, ${dateLabel(key)}`);
        days.append(button);
      });
      const { profileFor, programmeTitle, createCover } = programmes();
      const items = weekItems.filter(item => berlinDayKey(item.startsAt) <= selectedDay && berlinDayKey(new Date(Date.parse(item.endsAt) - 1)) >= selectedDay);
      const list = element('ol', 'radio-agenda-list unstyled-list');
      if (!items.length) list.append(element('li','radio-note',weekStatus === 'loading' ? 'Programm wird geladen …' : weekStatus === 'error' ? 'Programm gerade nicht erreichbar. Bitte versuche es erneut.' : 'Für diesen Tag ist noch kein Programm eingetragen.'));
      items.forEach(item => {
        const profile = profileFor(item);
        const title = programmeTitle(item);
        const live = Date.parse(item.startsAt) <= Date.now() && Date.parse(item.endsAt) > Date.now() && selectedDay === today;
        const from = berlinDayKey(item.startsAt) < selectedDay ? '00:00' : formatTime(item.startsAt);
        const to = berlinDayKey(item.endsAt) > selectedDay ? '24:00' : formatTime(item.endsAt);
        const row = element('li', `radio-agenda-row${live ? ' is-now' : ''}`);
        row.dataset.radioSlot = slotAnchor(item);
        if (slotHighlight.id === row.dataset.radioSlot && Date.now() < slotHighlight.until) row.classList.add('is-target');
        const time = element('div','radio-agenda-time');
        const start = element('time','',from); start.dateTime = item.startsAt;
        const end = element('time','',to); end.dateTime = item.endsAt;
        time.append(start,element('span','radio-agenda-until','bis'),end);
        if (live) time.append(element('span','radio-agenda-live','Jetzt live'));
        const cover = createCover ? createCover(item, 'radio-show-cover', 64) : element('span', 'radio-show-cover');
        cover.setAttribute('aria-hidden','true');
        cover.style.setProperty('--show-color',profile.color || '#b8ac9a');
        const copy = element('div','radio-agenda-copy');
        const heading = element('div','radio-agenda-heading');
        const titleLine = element('div', 'radio-agenda-titleline');
        titleLine.append(element('h3','',title));
        heading.append(titleLine);
        if(profile.genre) heading.append(element('span','radio-agenda-genre',profile.genre));
        copy.append(heading,element('p','',profile.description || 'Eine handkuratierte Auswahl aus unserem Radio: neue Entdeckungen und Lieblingsplatten, die bleiben.'));
        if (/crooked/i.test(item.programHandle || item.title || '') && root.querySelector('#shows [data-radio-recording]')) {
          const rewind = element('a', 'radio-agenda-rewind', 'Vergangene Folgen hören');
          rewind.href = '#shows'; copy.append(rewind);
        }
        {
          const key = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          const wanted = [item.programHandle, item.title].map(key).filter(Boolean);
          const tile = [...root.querySelectorAll('#playlists [data-radio-playlist]')].find(node => wanted.includes(key(node.dataset.radioPlaylist)));
          if (tile && tile.id) {
            const playlist = element('a', 'radio-agenda-rewind', 'Als Playlist weiterhören');
            playlist.href = `#${tile.id}`; copy.append(playlist);
          }
        }
        row.append(time,cover,copy);
        if (window.AsIfRadioCalendar) {
          const actions = element('div', 'radio-agenda-actions');
          const push = element('button', 'radio-agenda-notify');
          push.type = 'button'; push.append(icon('bell'));
          push.dataset.radioCalendarKey = JSON.stringify([item.startsAt, item.endsAt, title]);
          push.dataset.radioReminderShow = item.programHandle || '';
          push.dataset.radioReminderStart = item.startsAt;
          push.setAttribute('aria-label', `${root.dataset.reminderAction}: ${title}`);
          push.setAttribute('aria-haspopup', 'dialog');
          push.title = root.dataset.reminderAction;
          push.addEventListener('click', () => document.dispatchEvent(new CustomEvent('asif:reminder-open', {detail:{item:{...item,title},opener:push}})));
          actions.append(push); row.append(actions);
        }
        list.append(row);
      });
      timeline.append(list);
      document.dispatchEvent(new CustomEvent('asif:reminder-ui'));
      revealSlot();
      if (focusedDay) days.querySelector(`[data-radio-day="${focusedDay}"]`)?.focus({ preventScroll: true });
      if (focusedCalendar) {
        const replacement = [...timeline.querySelectorAll('[data-radio-calendar-key]')].find(button => button.dataset.radioCalendarKey === focusedCalendar);
        if (replacement) replacement.focus({ preventScroll: true });
        else {
          timeline.setAttribute('tabindex', '-1');
          timeline.focus({ preventScroll: true });
        }
      }
    };
    let slotTimer = 0;
    const revealSlot = () => {
      if (!slotTarget || !timeline) return;
      const row = slotTarget.now
        ? timeline.querySelector('.radio-agenda-row.is-now')
        : timeline.querySelector(`[data-radio-slot="${slotTarget.id}"]`);
      if (!row && weekStatus === 'loading') return;
      const smooth = slotTarget.smooth && !reduceMotion.matches;
      slotTarget = null;
      const target = row || root.querySelector('#programm');
      if (!target) return;
      window.requestAnimationFrame(() => {
        target.scrollIntoView({ block: 'start', behavior: smooth ? 'smooth' : 'auto' });
        if (!row) return;
        slotHighlight = { id: row.dataset.radioSlot, until: Date.now() + 2400 };
        timeline.querySelectorAll('.radio-agenda-row.is-target').forEach((node) => node.classList.remove('is-target'));
        row.classList.add('is-target');
        row.setAttribute('tabindex', '-1');
        row.focus({ preventScroll: true });
        window.clearTimeout(slotTimer);
        slotTimer = window.setTimeout(() => {
          timeline.querySelectorAll('.radio-agenda-row.is-target').forEach((node) => node.classList.remove('is-target'));
        }, 2400);
      });
    };
    const goToSlot = (hash, smooth = false) => {
      const wanted = readSlotHash(hash);
      if (!wanted) return false;
      const keys = programmeDates();
      const day = wanted.day && keys.includes(wanted.day) ? wanted.day : keys[0];
      slotTarget = { ...wanted, smooth };
      if (day !== selectedDay) { selectedDay = day; loadWeek(); }
      else renderSchedule();
      return true;
    };
    // Links auf eine Sendung (Heute-Streifen, Player unten) auf dieser Seite:
    // kein nativer Sprung, sondern Tag waehlen, Zeile zeigen, kurz markieren.
    const onSlotLink = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest?.('a[href*="#programm-"]');
      if (!link) return;
      let url;
      try { url = new URL(link.href, window.location.href); } catch { return; }
      if (url.pathname !== window.location.pathname || !readSlotHash(url.hash)) return;
      event.preventDefault();
      if (window.location.hash !== url.hash) history.replaceState(history.state, '', url.hash);
      goToSlot(url.hash, true);
    };
    const onHashChange = () => { goToSlot(window.location.hash, true); };
    // Einstieg mit #programm-... (Link von einer anderen Seite oder geteilt).
    {
      const initial = readSlotHash(window.location.hash);
      if (initial) {
        const keys = programmeDates();
        selectedDay = initial.day && keys.includes(initial.day) ? initial.day : keys[0];
        slotTarget = { ...initial, smooth: false };
      }
    }
    const loadWeek = async () => {
      if (disposed || !root.isConnected || document.hidden) return;
      const keys = programmeDates();
      if (!keys.includes(selectedDay)) selectedDay = keys[0];
      const key = selectedDay;
      for (const cachedDay of dayCache.keys()) if (!keys.includes(cachedDay)) dayCache.delete(cachedDay);
      if (weekController && requestDay === key) return;
      cancelDayRequest();
      const cached = dayCache.get(key);
      if (cached && Date.now() - cached.loadedAt < 300000) {
        weekItems = cached.items; weekStatus = cached.status; renderSchedule(); return;
      }
      const endpoint = document.querySelector('[data-asif-radio-root]')?.dataset.scheduleApi;
      if (!endpoint) return;
      weekItems = cached?.items || [];
      weekStatus = 'loading'; renderSchedule();
      const controller = new AbortController();
      weekController = controller; requestDay = key;
      const generation = requestGeneration;
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        const stamp = Date.parse(`${key}T00:00:00Z`);
        const url = new URL(endpoint);
        // Covers both Berlin offsets, including 23/25-hour DST days. The UI
        // filters overlaps to the selected local calendar day as before.
        url.searchParams.set('from', new Date(stamp - 7200000).toISOString());
        url.searchParams.set('to', new Date(stamp + 86400000).toISOString());
        const response = await fetch(url, { signal: controller.signal, credentials: 'omit' });
        if (!response.ok) throw new Error('schedule');
        const data = await response.json();
        if (!Array.isArray(data.items)) throw new Error('schedule');
        if (disposed || !root.isConnected || generation !== requestGeneration) return;
        if (!programmeDates().includes(key)) { cancelDayRequest(); loadWeek(); return; }
        const items = data.items.filter(item => item.title && Number.isFinite(Date.parse(item.startsAt)) && Date.parse(item.endsAt) > Date.parse(item.startsAt));
        weekItems = [...new Map(items.map(item => [`${item.startsAt}|${item.endsAt}|${item.title}`, item])).values()].sort((a,b) => Date.parse(a.startsAt)-Date.parse(b.startsAt));
        weekStatus = 'ready';
        dayCache.set(key, { items: weekItems, status: weekStatus, loadedAt: Date.now() });
      } catch (error) {
        if (disposed || !root.isConnected || generation !== requestGeneration) return;
        weekStatus = 'error';
        dayCache.set(key, { items: weekItems, status: weekStatus, loadedAt: Date.now() });
      } finally { window.clearTimeout(timeout); if (weekController === controller) { weekController = null; requestDay = ''; } }
      if (!disposed && root.isConnected && generation === requestGeneration && !document.hidden) renderSchedule();
    };
    renderSchedule(); loadWeek();

    /* --- Tracklist und Favoriten ----------------------------------------- */

    const renderHistory = (items, dataStatus, favorites) => {
      if (!historyList) return;
      historyList.replaceChildren();
      if (!items.length) {
        const message = dataStatus === 'unavailable' ? 'Tracklist gerade nicht erreichbar.'
          : dataStatus === 'empty' ? 'Noch keine zuletzt gespielten Titel.' : 'Tracklist wird geladen.';
        historyList.append(element('li', 'radio-note', message));
        if (historyFoot) historyFoot.hidden = true;
        return;
      }
      items.slice(0, historyLimit).forEach((item) => historyList.append(tile(item, favorites, 'history')));
      if (historyFoot) historyFoot.hidden = items.length <= historyLimit;
      if (historyMore) { const rest = Math.max(0, items.length - historyLimit); historyMore.textContent = rest === 1 ? 'Noch 1 Titel zeigen' : `Noch ${rest} Titel zeigen`; }
    };

    const recordingTile = (entry) => {
      const card = [...root.querySelectorAll('[data-radio-recording]')].find(card => window.AsIfRadioCollection?.canonicalURL(card.dataset.soundcloudUrl) === entry.url);
      const title = card?.dataset.recordingTitle || entry.title;
      const li = element('li', 'radio-tile');
      const open = element(card ? 'a' : 'div', 'radio-tile__open');
      if (card) { open.href = `#${card.id}`; open.dataset.savedOpen = entry.url; }
      const cover = card?.querySelector('.radio-recording__cover');
      open.append(artwork({ artworkUrl: cover?.currentSrc || cover?.src }, title, 320));
      const copy = element('span', 'radio-tile__copy');
      copy.append(element('strong', '', title));
      const provider = element('span', 'radio-tile__provider');
      const logo = document.createElement('img');
      logo.src = favoritesList.dataset.soundcloudIcon; logo.alt = ''; logo.width = 24; logo.height = 24;
      provider.append(logo, document.createTextNode('SoundCloud'));
      copy.append(provider);
      if (!card) copy.append(element('span', '', favoritesList.dataset.unavailable));
      const time = element('time', '', formatTime(entry.savedAt));
      time.dateTime = new Date(entry.savedAt).toISOString(); copy.append(time);
      open.append(copy); li.append(open);
      const remove = element('button', 'radio-tile__heart');
      remove.type = 'button'; remove.dataset.savedRemove = entry.url;
      remove.setAttribute('aria-pressed', 'true');
      remove.setAttribute('aria-label', `${title} aus Favoriten entfernen`);
      remove.append(icon('heart')); li.append(remove);
      return li;
    };

    const renderFavorites = (items) => {
      if (!favoritesList) return;
      const active = document.activeElement;
      const focusedIndex = [...favoritesList.querySelectorAll('.radio-tile__heart')].indexOf(active);
      favoritesList.replaceChildren();
      const recordings = window.AsIfRadioCollection?.getEntries() || [];
      if (!items.length && !recordings.length) {
        const empty = element('li', 'radio-empty');
        empty.append(icon('heart'));
        const copy = element('div', 'radio-empty__copy');
        copy.append(element('strong', '', root.dataset.radioEmptyTitle));
        copy.append(element('p', '', root.dataset.radioEmptyText));
        const discover = element('a', 'radio-button', root.dataset.radioEmptyAction);
        discover.href = '#tracklist';
        copy.append(discover);
        empty.append(copy);
        favoritesList.append(empty);
        if (focusedIndex >= 0) discover.focus({ preventScroll: true });
        return;
      }
      const combined = [...items.map(item => ({ item, date: Date.parse(item.savedAt) || 0 })), ...recordings.map(item => ({ item, recording: true, date: item.savedAt }))].sort((a, b) => b.date - a.date);
      combined.forEach(({ item, recording }) => favoritesList.append(recording ? recordingTile(item) : tile({ ...item, track: item }, items, 'favorites')));
      if (focusedIndex >= 0) favoritesList.querySelectorAll('.radio-tile__heart')[Math.min(focusedIndex, combined.length - 1)]?.focus({ preventScroll: true });
    };

    /* --- Titelkarte: liegt im Hub (asif-hub.js), hier nur der Aufruf ------ */
    const openCard = (trackId, source, opener) => {
      document.dispatchEvent(new CustomEvent('asif:track:open', { detail: { trackId, source, opener } }));
    };

    /* --- Bereichsleiste: aktiver Abschnitt ------------------------------- */

    const navLinks = nav ? [...nav.querySelectorAll('a[href^="#"]')] : [];
    const sections = navLinks.map((link) => link.getAttribute('href') === '#radio' ? root : root.querySelector(link.getAttribute('href'))).filter(Boolean);
    let activeId = '';
    const setActive = (id) => {
      if (id === activeId) return;
      activeId = id;
      navLinks.forEach((link) => {
        const current = link.getAttribute('href') === `#${id}`;
        if (current) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        if (current && nav) {
          const track = nav.querySelector('.radio-nav__track');
          if (track && track.scrollWidth > track.clientWidth) {
            const left = link.offsetLeft - (track.clientWidth - link.offsetWidth) / 2;
            track.scrollTo({ left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          }
        }
      });
    };
    let spyFrame = 0;
    const spy = () => {
      spyFrame = 0;
      if (!sections.length) return;
      const navRect = nav?.getBoundingClientRect();
      const docked = nav && window.getComputedStyle(nav).position === 'fixed';
      const headerHeight = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      if (window.scrollY <= 1 || (!docked && navRect?.top > headerHeight + 1)) { setActive('radio'); return; }
      // Read the upper third of the visible content, excluding either nav layout.
      const contentTop = docked
        ? (parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0)
        : (navRect?.bottom || 0);
      const contentBottom = docked ? navRect.top : window.innerHeight;
      const line = contentTop + Math.max(0, contentBottom - contentTop) * 0.3;
      let current = '';
      sections.forEach((section) => { if (section.getBoundingClientRect().top <= line) current = section.id; });
      if (!current && window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) current = sections[sections.length - 1].id;
      setActive(current);
    };
    const onScroll = () => { if (!spyFrame) spyFrame = window.requestAnimationFrame(spy); };

    /* --- Zustand ---------------------------------------------------------- */

    const renderState = (state) => {
      if (!state) return;
      lastState = state;
      if (document.hidden) return;
      const nextSchedule = `${state.scheduleStatus}${scheduleSignature(state.schedule || [])}${selectedDay}`;
      const nextFavorites = favoritesSignature(state.favorites || []);
      const nextHistory = `${state.historyStatus}${historySignature(state.history || [])}${nextFavorites}${historyLimit}`;
      if (nextSchedule !== lastScheduleSignature) { lastScheduleSignature = nextSchedule; renderSchedule(state.schedule || [], state.scheduleStatus); }
      if (nextHistory !== lastHistorySignature) { lastHistorySignature = nextHistory; renderHistory(state.history || [], state.historyStatus, state.favorites || []); }
      if (nextFavorites !== lastFavoritesSignature) {
        lastFavoritesSignature = nextFavorites;
        renderFavorites(state.favorites || []);
      }
      if (airplayHint) airplayHint.hidden = state.airPlayAvailable === true;
    };

    const requestSharedData = () => {
      if (!window.AsIfRadio?.ensureData) return;
      window.AsIfRadio.ensureData({ schedule: true, history: true });
      renderState(window.AsIfRadio.getState());
    };

    /* --- Klicks ----------------------------------------------------------- */

    const onRootClick = (event) => {
      const radioLink = event.target.closest('[data-radio-nav] a[href="#radio"]');
      if (radioLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        const heading = root.querySelector('h1');
        heading?.setAttribute('tabindex', '-1');
        heading?.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'instant' : 'smooth' });
        return;
      }
      const guideTab = event.target.closest('[data-radio-guide-tab]');
      if (guideTab && guideTabs.includes(guideTab)) { selectGuide(guideTabs.indexOf(guideTab)); return; }
      if (historyMore && event.target.closest('[data-radio-history-more]') === historyMore) {
        historyLimit += 6;
        renderState(lastState);
        return;
      }
      if (event.target.closest('[data-radio-week-retry]')) { dayCache.delete(selectedDay); cancelDayRequest(); loadWeek(); return; }
      const dayButton = event.target.closest('[data-radio-day]');
      if (dayButton && root.contains(dayButton)) {
        if (dayButton.dataset.radioDay === selectedDay) return;
        selectedDay = dayButton.dataset.radioDay;
        loadWeek();
        return;
      }
      const opener = event.target.closest('[data-radio-open]');
      if (opener && root.contains(opener)) openCard(opener.dataset.radioOpen, opener.dataset.radioSource, opener);
    };

    const onCollection = () => renderFavorites(lastState?.favorites || []);
    root.addEventListener('asif:collection-change', onCollection);
    const onState = (event) => renderState(event.detail);
    const onReady = () => { requestSharedData(); loadWeek(); };

    root.addEventListener('click', onRootClick);
    document.addEventListener('click', onSlotLink);
    window.addEventListener('hashchange', onHashChange);
    root.addEventListener('keydown', onGuideKey);
    window.addEventListener('asif:radio-state', onState);
    window.addEventListener('asif:radio-ready', onReady);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    const refreshVisibleSchedule = () => {
      if (document.hidden || disposed || document.querySelector('.radio-reminder-dialog[open]')) return;
      if (!days.contains(document.activeElement)) { lastScheduleSignature = ''; renderState(lastState); }
      loadWeek();
    };
    const onVisibility = () => {
      window.clearInterval(clockTimer); clockTimer = 0;
      if (document.hidden) { cancelDayRequest(); return; }
      refreshVisibleSchedule();
      clockTimer = window.setInterval(refreshVisibleSchedule, 30000);
    };
    document.addEventListener('visibilitychange', onVisibility);
    onVisibility();
    requestSharedData();
    spy();

    mounts.set(root, () => {
      archiveCleanups.forEach(cleanup => cleanup());
      disposed = true;
      cancelDayRequest();
      document.removeEventListener('visibilitychange', onVisibility);
      window.clearInterval(clockTimer);
      window.cancelAnimationFrame(spyFrame);
      root.removeEventListener('asif:collection-change', onCollection);
      root.removeEventListener('click', onRootClick);
      document.removeEventListener('click', onSlotLink);
      window.removeEventListener('hashchange', onHashChange);
      window.clearTimeout(slotTimer);
      root.removeEventListener('keydown', onGuideKey);
      window.removeEventListener('asif:radio-state', onState);
      window.removeEventListener('asif:radio-ready', onReady);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      mounts.delete(root);
    });
  }

  document.querySelectorAll('[data-radio-page]').forEach(mount);
  // SPA-Vertrag (asif-spa.js): Seitentausch ohne Neuladen.
  document.addEventListener('asif:page', (event) => {
    if (event.detail?.initial) return;
    document.querySelectorAll('[data-radio-page]').forEach(mount);
  });
  document.addEventListener('asif:page:unload', () => {
    mounts.forEach((cleanup, root) => { if (!root.isConnected || root.closest('main')) cleanup(); });
  });
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-radio-page]') || event.target.closest?.('[data-radio-page]');
    if (root) mount(root);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector?.('[data-radio-page]') || event.target.closest?.('[data-radio-page]');
    mounts.get(root)?.();
  });
})();
